import { Component, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FeeService } from '../service/fee.service';
import { MemberSubgroupInfo } from '../interface/fee.interface';

export interface RemoveSubgroupConfirmDialogData {
  memberId: number;
  subgroup: MemberSubgroupInfo;
}

@Component({
  selector: 'app-fee-remove-subgroup-confirm-dialog',
  templateUrl: './fee-remove-subgroup-confirm-dialog.component.html',
  styleUrls: ['./fee-remove-subgroup-confirm-dialog.component.scss']
})
export class FeeRemoveSubgroupConfirmDialogComponent implements OnDestroy {

  private readonly destroy$ = new Subject<void>();
  removing = false;

  constructor(
    private readonly dialogRef: MatDialogRef<FeeRemoveSubgroupConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) readonly data: RemoveSubgroupConfirmDialogData,
    private readonly feeService: FeeService
  ) {}

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  confirm(): void {
    if (this.removing) return;
    this.removing = true;
    this.feeService.removeMemberFromSubgroup(this.data.memberId, this.data.subgroup.id)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: () => this.dialogRef.close(true),
        error: () => { this.removing = false; }
      });
  }

  cancel(): void {
    this.dialogRef.close(false);
  }
}
